// extracted by mini-css-extract-plugin
module.exports = {"container":"_8LH6Orss-aWaJLKrtETLZ","closeIcon":"_3dIHjyqnuDBFdas1jERFU3"};